import { render, staticRenderFns } from "./HistoryNotifications.vue?vue&type=template&id=0cf86393&scoped=true"
import script from "./HistoryNotifications.vue?vue&type=script&lang=js"
export * from "./HistoryNotifications.vue?vue&type=script&lang=js"
import style0 from "./HistoryNotifications.vue?vue&type=style&index=0&id=0cf86393&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf86393",
  null
  
)

export default component.exports